if(!customElements.get('product-block-slider')) {

  class ProductBlockSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.id = this.getAttribute('data-id');
      this.isEnabled = false;
      this.isDesktop = false;
      this.DESKTOP_WIDTH = 1024;
      this.mobileSlides = SLIDES_PER_VIEW_MOBILE_DEFAULTS;
      this.desktopSlides = SLIDES_PER_VIEW_DESKTOP_DEFAULTS;
    }

    connectedCallback() {
      this.isEnabled = this.getAttribute('data-swiper-enable') === 'true';
      this.isDesktop = window.innerWidth > this.DESKTOP_WIDTH;
      this.mobileSlides = getSlidesConfig(
        this.dataset.slidesPerViewMobile,
        SLIDES_PER_VIEW_MOBILE_DEFAULTS
      );
      this.desktopSlides = getSlidesConfig(
        this.dataset.slidesPerViewDesktop,
        SLIDES_PER_VIEW_DESKTOP_DEFAULTS
      );
      this.initProductBlockSlider();
    }

    disconnectedCallback() {
      this.destroyProductBlockSlider();
    }

    initProductBlockSlider() {
      const productCarouselID = `#product-carousel-${this.id}`;
      const isSwiperEnable = this.isDesktop ? this.isEnabled : true;

      const navigationEnabled = {
        navigation: {
          nextEl: `#swiper-button-next-${this.id}`,
          prevEl: `#swiper-button-prev-${this.id}`,
        },
      };

      if (!isSwiperEnable) {
        const navigationWrapper = this.querySelector(
          `#swiper-navigation-wrapper-${this.id}`
        );
        navigationWrapper?.classList?.add('!hidden');
      }

      this.swiperInstance = new Swiper(productCarouselID, {
        speed: DEFAULT_SLIDER_SPEED,
        spaceBetween: 16,
        ...this.mobileSlides,
        loop: false,
        preventInteractionOnTransition: true,
        centeredSlides: false,
        // Fractional slide widths leave cards on half pixels, where iOS shows a
        // 1px sliver of the neighbouring image at the card edges.
        roundLengths: true,
        ...navigationEnabled,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          [this.DESKTOP_WIDTH]: {
            spaceBetween: 24,
            ...this.desktopSlides,
          },
        },
        on: {
          init: function () {
            this?.el?.classList.remove('opacity-0');
          },
        },
      });
    }

    destroyProductBlockSlider() {
      if (this.swiperInstance) {
        try {
          if (this.swiperInstance.destroyed) {
            console.info('Swiper already destroyed');
            this.swiperInstance = null;
            return;
          }
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        } catch (error) {
          console.error('Error destroying Swiper:', error);
          this.swiperInstance = null;
        }
      } else {
        console.log('No Swiper instance to destroy');
      }
    }
  }

  customElements.define('product-block-slider', ProductBlockSlider);
}

